import { render, staticRenderFns } from "./SmallPhotoSwiper.vue?vue&type=template&id=27f952f4"
import script from "./SmallPhotoSwiper.vue?vue&type=script&lang=ts"
export * from "./SmallPhotoSwiper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports